import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import {
  Divider,
  Stack,
  Grid,
  Card,
  styled,
  CircularProgress,
} from "@mui/material";
import leadFormStyles from "../Leads Page/leadFormStyles.module.css";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  IconButton,
  FormHelperText,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import bdmFormStyles from "./bdmFormStyles.module.css";
import { CREATE_MEETING, MODEL_TYPE } from "../../constants";
import DeleteIcon from "@mui/icons-material/Delete";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import axios from "axios";
import DispositionModalComponent from "../reusable Component/DispositionModalComponent";
import { useMediaQuery, useTheme, Chip } from "@mui/material";
import imageCompression from "browser-image-compression";
import Loader from "../reusable Component/Loader";

const ResizableTextField = styled(TextField)({
  "& .MuiInputBase-root": {
    "& textarea": {
      resize: "both", // Allow resizing both horizontally and vertically
      overflow: "auto", // Show scrollbars when necessary
      minHeight: "100px", // Set a minimum height for the textarea
    },
  },
});

function MeetingFormComponent({
  rowDetails,
  setShowMeetingForm,
  leadDetailsId,
  setSeverity,
  setMessage,
  setOpenSnackbar,
  setLoading,
  setRunEffect,
  setOpenTaskDialog,
  travelDetailsId,
  placeOfSubmit,
  fetchDailyTasks,
  handleCloseFormDialog,
  bdmLeadActionId,
  typeOfTask
}) {
  const [birdCapacity, setBirdCapacity] = useState("");
  const [landDimension, setLandDimension] = useState("");
  const [shedSize, setShedSize] = useState("");
  const [modelType, setModelType] = useState("");
  const [landDirection, setLandDirection] = useState("");
  const [directionDeviation, setDirectionDeviation] = useState(null);
  const [electricityPower, setElectricityPower] = useState("");
  const [water, setWater] = useState("");
  const [approachRoad, setApproachRoad] = useState("");
  const [estimationReq, setEstimationReq] = useState("");
  const [images, setImages] = useState([]);

  const [dDShow, setDDShow] = useState(false);

  const [open, setOpen] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [bdmSelfie, setBdmSelfie] = useState(null);
  const [bdmSelfieShow, setBdmSelfieShow] = useState(null);
  const [customerSelfie, setCustomerSelfie] = useState(null);
  const [customerSelfieShow, setCustomerSelfieShow] = useState(null);
  const [otherImages, setOtherImages] = useState([]);
  const [otherImagesShow, setOtherImagesShow] = useState([]);
  const [imagesError, setImagesError] = useState("");
  const [imagesCustomerError, setImagesCustomerError] = useState("");

  const [loading1, setLoading1] = useState(false);

  const compressImage = async (imageFile) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          const maxWidth = 800;
          const maxHeight = 600;
          let width = img.width;
          let height = img.height;
          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }
          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }
          canvas.width = width;
          canvas.height = height;
          // Clear the canvas before drawing (fixes black image issue)
          ctx.clearRect(0, 0, canvas.width, canvas.height);

          // Ensure the image is drawn properly
          ctx.drawImage(img, 0, 0, width, height);

          canvas.toBlob(
            (blob) => {
              // Convert blob back to a File object
              const compressedFile = new File([blob], imageFile.name, {
                type: imageFile.type,
              });
              resolve(compressedFile);
            },
            imageFile.type, // Keep the original MIME type (image/jpeg or image/png)
            0.7 // Compression quality (adjust as needed)
          );
        };
        img.src = reader.result;
      };
      reader.readAsDataURL(imageFile);
    });
  };

  const handleBDMSelfieChange = async (event) => {
    const file = event.target.files[0];
    if (file && (file.type === "image/jpeg" || file.type === "image/png")) {
      setLoading1(true); // Show loader
      const compressedFile = await compressImage(file);
      const imageUrl = URL.createObjectURL(file); // Show original image
      setBdmSelfie(compressedFile); // Save compressed image
      setBdmSelfieShow(imageUrl);
      setImagesError("");
      setLoading1(false); // Hide loader
    } else {
      setImagesError("Only PNG and JPEG files are allowed.");
    }
  };

  const [loadingCustomer, setLoadingCustomer] = useState(false);
  const [loadingOther, setLoadingOther] = useState(false);

  const handleCustomerSelfieImageChange = async (event) => {
    const file = event.target.files[0];
    if (file && (file.type === "image/jpeg" || file.type === "image/png")) {
      setLoadingCustomer(true); // Show loader
      const compressedFile = await compressImage(file);
      const imageUrl = URL.createObjectURL(file); // Show original image
      setCustomerSelfie(compressedFile); // Save compressed image
      setCustomerSelfieShow(imageUrl);
      setImagesCustomerError("");
      setLoadingCustomer(false); // Hide loader
    } else {
      setImagesCustomerError("Only PNG and JPEG files are allowed.");
      setLoadingCustomer(false);
    }
  };

  const handleMultipleUpload = async (event) => {
    const files = Array.from(event.target.files);

    const validImages = files.filter(
      (file) => file.type === "image/jpeg" || file.type === "image/png"
    );

    if (validImages.length !== files.length) {
      setImagesError("Only PNG and JPEG files are allowed.");
      return;
    }

    setLoadingOther(true); // Show loader
    const compressedImages = await Promise.all(validImages.map(compressImage));
    const newImagesShow = validImages.map((file) => URL.createObjectURL(file)); // Show original images
    setOtherImagesShow([...otherImagesShow, ...newImagesShow]);
    setOtherImages([...otherImages, ...compressedImages]); // Save compressed images
    setImagesError("");
    setLoadingOther(false); // Hide loader
  };

  const handleBDMSelfieRemoveImage = () => {
    setBdmSelfie(null);
    setBdmSelfieShow(null);
  };

  const handleCustomerSelfieRemoveImage = () => {
    setCustomerSelfie(null);
    setCustomerSelfieShow(null);
  };

  const handleRemoveMultipleImage = (index) => {
    const updatedImages = otherImages.filter((_, i) => i !== index);
    setOtherImages(updatedImages);

    const updatedImages1 = otherImagesShow.filter((_, i) => i !== index);
    setOtherImagesShow(updatedImages1);
  };

  const [remark, setRemark] = useState("");
  const [remarkError, setRemarkError] = useState("");

  const handleChangeRemark = (e) => {
    setRemark(e.target.value);
  };

  const validateRemark = (value) => {
    if (value == "") {
      setRemarkError("Feild is required.");
      return false;
    } else {
      setRemarkError("");
      return true;
    }
  };

  const [landDirectionError, setLandDirectionError] = useState("");

  const validateLandDirection = (value) => {
    if (!value) {
      setLandDirectionError("Land Direction is required");
      return false;
    } else {
      setLandDirectionError("");
      return true;
    }
  };

  const handleChangeLandDirection = (e) => {
    const value = e.target.value;
    setLandDirection(value);
    validateLandDirection(value);
    if (value == "true") {
      setDDShow(false);
    } else {
      setDDShow(true);
    }
  };

  const [electricityPowerError, setElectricityPowerError] = useState("");
  const validateElectricityPower = (value) => {
    if (value == "") {
      setElectricityPowerError("Electricity Power is required");
      return false;
    } else {
      setElectricityPowerError("");
      return true;
    }
  };

  const handleChangeElectricityPower = (e) => {
    const value = e.target.value;
    setElectricityPower(value);
    validateElectricityPower(value);
  };

  const [waterError, setWaterError] = useState("");
  const validateWater = (value) => {
    if (!value) {
      setWaterError("Water is required.");
      return false;
    } else {
      setWaterError("");
      return true;
    }
  };

  const handleChangeWater = (e) => {
    const value = e.target.value;
    setWater(value);
    validateWater(value);
  };

  const [approachRoadError, setapproachRoadError] = useState("");
  const validateApproachRoad = (value) => {
    if (!value) {
      setapproachRoadError("Approachable Road is required.");
      return false;
    } else {
      setapproachRoadError("");
      return true;
    }
  };

  const handleChangeApproachRoad = (e) => {
    const value = e.target.value;
    setApproachRoad(value);
    validateApproachRoad(value);
  };

const handleShedSizeChange = (e) => {
  let rawValue = e.target.value.toUpperCase();

  // Allow empty input
  if (rawValue === "") {
    setShedSize("");
    return;
  }

  // Clean input to allow only numbers and 'X'
  let cleanedValue = rawValue.replace(/[^0-9X]/g, "");

  // Ensure it follows the format "3 digits X 2 digits"
  const validPattern = /^(\d{1,3})X?(\d{0,2})$/;
  const match = validPattern.exec(cleanedValue);

  if (match) {
    let formattedValue = match[1];
    if (match[2] !== undefined && match[2] !== "") {
      formattedValue += "X" + match[2];
    } else if (cleanedValue.includes("X")) {
      formattedValue += "X";
    }
    setShedSize(formattedValue);
  }
};



  const [EstimationReqError, setEstimationReqError] = useState("");
  const validateEstimationReq = (value) => {
    if (!value) {
      setEstimationReqError("Estimation Requirement is required.");
      return false;
    } else {
      setEstimationReqError("");
      return true;
    }
  };

  const handleChangeEstimationReq = (e) => {
    const value = e.target.value;
    setEstimationReq(value);
    validateEstimationReq(value);
  };

  const [ModelTypeError, setModelTypeError] = useState("");
  const validateModelType = (value) => {
    if (value == "") {
      setModelTypeError("Model Type is required.");
      return false;
    } else {
      setModelTypeError("");
      return true;
    }
  };

  const handleModelTypeChange = (e) => {
    const value = e.target.value;
    setModelType(value);
    validateModelType(value);
  };

  const [birdCapacityError, setBirdCapacityError] = useState("");

  const handleBirdCapacityChange = (e) => {
    let value = e.target.value;

    if (/^\d*$/.test(value) && Number(value) <= 100000) {
      setBirdCapacity(value);
      setBirdCapacityError(""); // Clear the error if the input is valid
    } else if (Number(value) > 100000) {
      setBirdCapacityError("Bird capacity cannot exceed 100,000.");
    }
  };

  const validateBirdCapacity = (value) => {
    if (value == "") {
      setBirdCapacityError("Feild is required.");
      return false;
    } else {
      setBirdCapacityError("");
      return true;
    }
  };

  const [landDimensionError, setLandDimensionError] = useState("");

  const validatelandDimension = (value) => {
    if (value == "") {
      setLandDimensionError("Feild is required.");
      return false;
    } else {
      setLandDimensionError("");
      return true;
    }
  };

  const [ShedSizeError, setShedSizeError] = useState("");

  const validateShedSize = (value) => {
    if (value == "") {
      setShedSizeError("Feild is required.");
      return false;
    } else {
      setShedSizeError("");
      return true;
    }
  };

  const [bdmSelfieError, setBdmSelfieError] = useState("");
  const [customerSelfieError, setCustomerSelfieError] = useState("");

  const validateBdmSelfie = (value) => {
    if (!value) {
      setBdmSelfieError("Image is required.");
      return false;
    } else {
      setBdmSelfieError("");
      return true;
    }
  };

  const validateCustomerSelfie = (value) => {
    if (!value) {
      setCustomerSelfieError("Image is required.");
      return false;
    } else {
      setCustomerSelfieError("");
      return true;
    }
  };

  const handleClose = (e) => {
    e.preventDefault();
    setShowMeetingForm(false);
    // if(viewMode){
    // handleViewMode(false);}
  };

  const [meetingFormData, setMeetingFormData] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();

    // Perform all validations
    const isbirdCapacityValid = validateBirdCapacity(birdCapacity);
    const isLandDimensionValid = validatelandDimension(landDimension);
    const isShedSizeValid = validateShedSize(shedSize);
    const islandDirectionValid = validateLandDirection(landDirection);
    const isElectricityPowerValid = validateElectricityPower(electricityPower);
    const isWaterValid = validateWater(water);
    const isApproachRoadValid = validateApproachRoad(approachRoad);
    const isEstimationReqValid = validateEstimationReq(estimationReq);
    const isModelTypeValid = validateModelType(modelType);
    const isBdmSelfieValid = validateBdmSelfie(bdmSelfie);
    const isCustomerSelfieValid = validateCustomerSelfie(customerSelfie);
    const isRemarkValid = validateRemark(remark);

    // Check if any of the validation flags are false (meaning the form is invalid)
    if (
      !isbirdCapacityValid ||
      !isLandDimensionValid ||
      !isShedSizeValid ||
      !islandDirectionValid ||
      !isElectricityPowerValid ||
      !isWaterValid ||
      !isApproachRoadValid ||
      !isEstimationReqValid ||
      !isModelTypeValid ||
      !isBdmSelfieValid ||
      !isCustomerSelfieValid ||
      !isRemarkValid
    ) {
      console.log("Form not submitted, validation failed");
      return; // Stop form submission if any validation fails
    }

    // Proceed with form submission if all validations pass
    const formData = new FormData();
    formData.append("LeadDetailId", leadDetailsId);
    formData.append("BDMId", localStorage.getItem("username"));
    formData.append("BirdsCapacity", birdCapacity);
    formData.append("LandDimension", landDimension);
    formData.append("ShedSize", shedSize);
    formData.append("ModelType", modelType);
    formData.append("IsLandDirectionEastWest", landDirection === "true");
    formData.append("DirectionDeviationDegree", directionDeviation);
    formData.append("ElectricityPower", electricityPower === "true");
    formData.append("Water", water === "true");
    formData.append("ApproachRoad", approachRoad === "true");
    formData.append("EstimationRequirement", estimationReq === "true");
    formData.append("ActionType", "meeting");
    formData.append("remark", remark);

    // Append images to the formData (ensure multiple uploads are handled correctly)
    formData.append("images", bdmSelfie);
    formData.append("images", customerSelfie);
    otherImages.forEach((image) => {
      formData.append("images", image);
    });

    console.log("formData", formData);
    setMeetingFormData(formData);
    setOpen(true);
  };

  const resetForm = () => {
    setBirdCapacity("");
    setLandDimension("");
    setShedSize("");
    setModelType("");
    setLandDirection(null);
    setDirectionDeviation("");
    setElectricityPower(null);
    setWater(null);
    setApproachRoad(null);
    setEstimationReq(null);
    setImages([]);
    setRemark("");
    setBdmSelfie(null);
    setCustomerSelfie(null);
    setOtherImages([]);
  };

  return (
    <>
      {/* {loading1 && <Loader open={loading1} />} */}
      {/* <Card className={`${bdmFormStyles.form_card_style} mt-2`}> */}
      <Box
        component="form"
        sx={{
          "& .MuiTextField-root": { m: 1 },
        }}
        noValidate
        autoComplete="off"
      >
        <Grid container spacing={isMobile ? 0 : 2} p={isMobile ? 0 : 3}>
          <Grid item xs={12} md={4} xl={3}>
            <TextField
              label="Bird Capacity"
              id="outlined-size-small"
              value={birdCapacity}
              onChange={handleBirdCapacityChange}
              error={!!birdCapacityError}
              helperText={birdCapacityError}
              required
              size="small"
              fullWidth
              inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
            />
          </Grid>
          <Grid item xs={12} md={4} xl={3}>
            <TextField
              label="Land Dimension (Sqft)"
              id="outlined-size-small"
              value={landDimension}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value) && Number(value) <= 20000) {
                  setLandDimension(value);
                  setLandDimensionError(""); // Clear error if the input is valid
                } else if (Number(value) > 20000) {
                  setLandDimensionError(
                    "Land dimension cannot exceed 10,000 sqft."
                  );
                }
              }}
              error={!!landDimensionError}
              helperText={landDimensionError}
              required
              size="small"
              fullWidth
              inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
            />
          </Grid>
          <Grid item xs={12} md={4} xl={3}>
            <TextField
              label="Shed Size (L X W)"
              id="outlined-size-small"
              value={shedSize}
              onChange={handleShedSizeChange}
              size="small"
              error={!!ShedSizeError}
              helperText={ShedSizeError}
              fullWidth
              required
            />
          </Grid>

          <Grid item xs={12} md={4} xl={3}>
            <TextField
              id="outlined-select-currency"
              select
              label="Model Type"
              value={modelType}
              onChange={handleModelTypeChange}
              error={!!ModelTypeError}
              helperText={ModelTypeError}
              required
              fullWidth
              // helperText="Please select your currency"
              size="small"
            >
              {MODEL_TYPE.map((mt) => (
                <MenuItem
                  value={mt.label}
                  sx={{
                    borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                    marginBottom: "8px",
                    marginTop: "8px",
                  }}
                >
                  {mt.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} md={4} xl={3}>
            <div className={`px-2`}>
              <Typography variant="body2">
                Is land direction East West?{" "}
                <span style={{ color: "red" }}>*</span>
              </Typography>
              <RadioGroup
                aria-label="Is land direction East West?"
                name="gender"
                value={landDirection}
                onChange={handleChangeLandDirection}
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 16,
                  },
                  "& .MuiFormControlLabel-label": {
                    fontSize: 14,
                  },
                }}
              >
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value={false}
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
              {landDirectionError && (
                <FormHelperText error>{landDirectionError}</FormHelperText>
              )}
            </div>
          </Grid>

          {dDShow && (
            <Grid item xs={12} md={4} xl={3}>
              <TextField
                label="Direction Deviation Degree"
                id="outlined-size-small"
                value={directionDeviation}
                onChange={(e) => setDirectionDeviation(e.target.value)}
                size="small"
              />
            </Grid>
          )}

          <Grid item xs={12} md={4} xl={3}>
            <div className={`px-2`}>
              <Typography variant="body2">
                Electricity Power (Minimum 30kVa){" "}
                <span style={{ color: "red" }}>*</span>
              </Typography>
              <RadioGroup
                aria-label="Electricity Power (Minimum 30kVa)"
                name="epower"
                value={electricityPower}
                onChange={handleChangeElectricityPower}
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 16,
                  },
                  "& .MuiFormControlLabel-label": {
                    fontSize: 14,
                  },
                }}
              >
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value={false}
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
              {electricityPowerError && (
                <FormHelperText error>{electricityPowerError}</FormHelperText>
              )}
            </div>
          </Grid>

          <Grid item xs={12} md={4} xl={3}>
            <div className={`px-2`}>
              <Typography variant="body2">
                Water(Minimum 10000 lit./day){" "}
                <span style={{ color: "red" }}>*</span>
              </Typography>
              <RadioGroup
                aria-label="Water(Minimum 10000 lit./day)"
                name="water"
                value={water}
                onChange={handleChangeWater}
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 16,
                  },
                  "& .MuiFormControlLabel-label": {
                    fontSize: 14,
                  },
                }}
              >
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value={false}
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
              {waterError && (
                <FormHelperText error>{waterError}</FormHelperText>
              )}
            </div>
          </Grid>

          <Grid item xs={12} md={4} xl={3}>
            <div className={`px-2`}>
              <Typography variant="body2">
                Approachable Road <span style={{ color: "red" }}>*</span>
              </Typography>
              <RadioGroup
                aria-label="Approach Road"
                name="approch_road"
                value={approachRoad}
                onChange={handleChangeApproachRoad}
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 16,
                  },
                  "& .MuiFormControlLabel-label": {
                    fontSize: 14,
                  },
                }}
              >
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value={false}
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
              {approachRoadError && (
                <FormHelperText error>{approachRoadError}</FormHelperText>
              )}
            </div>
          </Grid>

          <Grid item xs={12} md={4} xl={3}>
            <div className={`px-2`}>
              <Typography variant="body2">
                Estimation Requirement <span style={{ color: "red" }}>*</span>
              </Typography>
              <RadioGroup
                aria-label="Estimation Requirement"
                name="ereq"
                value={estimationReq}
                onChange={handleChangeEstimationReq}
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 16,
                  },
                  "& .MuiFormControlLabel-label": {
                    fontSize: 14,
                  },
                }}
              >
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value={false}
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
              {EstimationReqError && (
                <FormHelperText error>{EstimationReqError}</FormHelperText>
              )}
            </div>
          </Grid>

          <Grid item xs={12} md={12} xl={12}>
            <ResizableTextField
              label={"Remarks"}
              value={remark}
              onChange={(e) => {
                if (e.target.value.length <= 250) {
                  handleChangeRemark(e);
                }
              }}
              multiline
              fullWidth
              variant="outlined" // Use 'outlined' for better border control
              style={{ width: "100%" }}
              required
              error={!!remarkError}
              helperText={remarkError}
            />
            <Typography
              variant="body2"
              color={remark.length > 250 ? "error" : "text.secondary"}
              sx={{ marginLeft: "7px" }}
            >
              {remark.length}/250
            </Typography>
          </Grid>

          <Grid container spacing={2} p={2}>
            {/* Label for the entire upload section */}
            <Grid item xs={12}>
              <Typography variant="body2">
                Upload Images <span style={{ color: "red" }}>*</span>
              </Typography>
            </Grid>

            {/* BDM Selfie */}
            <Grid item xs={12} md={4} xl={6}>
              <div className="px-2">
                {!bdmSelfie ? (
                  <>
                    <Button
                      variant="contained"
                      component="label"
                      color="primary"
                      startIcon={
                        loading1 ? <CircularProgress size={20} /> : <AddIcon />
                      }
                      sx={{
                        width: "60%",
                        marginTop: "8px",
                        textTransform: "none",
                        border: "2px dashed black",
                        backgroundColor: "lightgray",
                        "&:hover": {
                          backgroundColor: "gray",
                        },
                        cursor: loading1 ? "not-allowed" : "pointer",
                        opacity: loading1 ? 0.6 : 1,
                      }}
                      disabled={loading1} // Disable button when loading
                    >
                      {loading1 ? "Uploading..." : "BDM Selfie"}
                      <input
                        accept=".png, .jpeg, .jpg"
                        type="file"
                        onChange={(e) => handleBDMSelfieChange(e)}
                        style={{ display: "none" }}
                        disabled={loading1}
                      />
                    </Button>
                    <p style={{ color: "gray", fontSize: "0.875rem" }}>
                      Only PNG and JPEG files are allowed.
                    </p>
                    {imagesError && (
                      <FormHelperText error>{imagesError}</FormHelperText>
                    )}
                    {bdmSelfieError && (
                      <FormHelperText error>{bdmSelfieError}</FormHelperText>
                    )}
                  </>
                ) : (
                  <div>
                    {loading1 ? (
                      <CircularProgress size={40} />
                    ) : (
                      <>
                        <img
                          src={bdmSelfieShow}
                          alt="Uploaded BDM Selfie"
                          style={{ maxWidth: "150px", maxHeight: "150px" }}
                        />
                        <IconButton
                          onClick={() => handleBDMSelfieRemoveImage()}
                          aria-label="delete"
                          size="small"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </>
                    )}
                  </div>
                )}
              </div>
            </Grid>

            {/* /* Customer Selfie */}
            <Grid item xs={12} md={4} xl={6}>
              <div className="px-2">
                {!customerSelfie ? (
                  <>
                    <Button
                      variant="contained"
                      component="label"
                      color="primary"
                      startIcon={
                        loadingCustomer ? (
                          <CircularProgress size={20} />
                        ) : (
                          <AddIcon />
                        )
                      }
                      sx={{
                        width: "60%",
                        marginTop: "8px",
                        textTransform: "none",
                        border: "2px dashed black",
                        backgroundColor: "lightgray",
                        "&:hover": { backgroundColor: "gray" },
                        cursor: loadingCustomer ? "not-allowed" : "pointer",
                        opacity: loadingCustomer ? 0.6 : 1,
                      }}
                      disabled={loadingCustomer}
                    >
                      {loadingCustomer
                        ? "Uploading..."
                        : "BDM with Customer Selfie"}
                      <input
                        accept=".png, .jpeg, .jpg"
                        type="file"
                        onChange={(e) => handleCustomerSelfieImageChange(e)}
                        style={{ display: "none" }}
                        disabled={loadingCustomer}
                      />
                    </Button>
                    <p style={{ color: "gray", fontSize: "0.875rem" }}>
                      Only PNG and JPEG files are allowed.
                    </p>
                    {imagesCustomerError && (
                      <FormHelperText error>
                        {imagesCustomerError}
                      </FormHelperText>
                    )}
                    {customerSelfieError && (
                      <FormHelperText error>
                        {customerSelfieError}
                      </FormHelperText>
                    )}
                  </>
                ) : (
                  <div>
                    {loadingCustomer ? (
                      <CircularProgress size={40} />
                    ) : (
                      <>
                        <img
                          src={customerSelfieShow}
                          alt="Uploaded Customer Selfie"
                          style={{ maxWidth: "150px", maxHeight: "150px" }}
                        />
                        <IconButton
                          onClick={() => handleCustomerSelfieRemoveImage()}
                          aria-label="delete"
                          size="small"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </>
                    )}
                  </div>
                )}
              </div>
            </Grid>

            {/* /* Other Images */}
            <Grid item xs={12} md={4} xl={6}>
              <div className="px-2">
                {otherImages.length > 0 ? (
                  <Grid container spacing={1}>
                    {otherImagesShow.map((image, index) => (
                      <Grid item key={index}>
                        {loadingOther ? (
                          <CircularProgress size={40} />
                        ) : (
                          <>
                            <img
                              src={image}
                              alt={`Other ${index}`}
                              style={{ maxWidth: "100px", maxHeight: "100px" }}
                            />
                            <IconButton
                              onClick={() => handleRemoveMultipleImage(index)}
                              aria-label="delete"
                              size="small"
                            >
                              <DeleteIcon />
                            </IconButton>
                          </>
                        )}
                      </Grid>
                    ))}
                  </Grid>
                ) : (
                  <>
                    <Button
                      variant="contained"
                      component="label"
                      color="primary"
                      startIcon={
                        loadingOther ? (
                          <CircularProgress size={20} />
                        ) : (
                          <AddIcon />
                        )
                      }
                      sx={{
                        width: "60%",
                        marginTop: "8px",
                        textTransform: "none",
                        border: "2px dashed black",
                        backgroundColor: "lightgray",
                        "&:hover": { backgroundColor: "gray" },
                        cursor: loadingOther ? "not-allowed" : "pointer",
                        opacity: loadingOther ? 0.6 : 1,
                      }}
                      disabled={loadingOther}
                    >
                      {loadingOther ? "Uploading..." : "Other Images"}
                      <input
                        accept=".png, .jpeg, .jpg"
                        type="file"
                        multiple
                        onChange={handleMultipleUpload}
                        style={{ display: "none" }}
                        disabled={loadingOther}
                      />
                    </Button>
                    <p style={{ color: "gray", fontSize: "0.875rem" }}>
                      Only PNG and JPEG files are allowed.
                    </p>
                    {imagesError && (
                      <FormHelperText error>{imagesError}</FormHelperText>
                    )}
                  </>
                )}
              </div>
            </Grid>
          </Grid>
        </Grid>
        <div className={`float-right p-2`}>
          {!isMobile && (
            <Button
              onClick={handleClose}
              variant="contained"
              className={`${bdmFormStyles.button_space_style}`}
            >
              Cancel
            </Button>
          )}
          {/* {viewMode == true ? (<></>) : ( */}
          <Button type="submit" variant="contained" onClick={handleSubmit}>
            Save
          </Button>
        </div>
      </Box>

      {/* )} */}
      {/* </Card> */}

      <DispositionModalComponent
        open={open}
        setOpen={setOpen}
        meetingFormData={meetingFormData}
        setSeverity={setSeverity}
        setMessage={setMessage}
        setOpenSnackbar={setOpenSnackbar}
        setShowMeetingForm={setShowMeetingForm}
        formType={"meeting"}
        setRunEffect={setRunEffect}
        setLoading={setLoading}
        resetForm={resetForm}
        setOpenTaskDialog={setOpenTaskDialog}
        travelDetailsId={travelDetailsId}
        placeOfSubmit={placeOfSubmit}
        fetchDailyTasks={fetchDailyTasks}
        handleCloseFormDialog={handleCloseFormDialog}
        bdmLeadActionId={bdmLeadActionId}
        typeOfTask={typeOfTask}
        showExtraFields={true}
      />
    </>
  );
}

export default MeetingFormComponent;
